let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8wBwB")).then(() => parcelRequire('6x8VJ'));